import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Loader, MinLoader, NoItemsYet } from 'components';
import { payerCapabilitiesBody, payerCapabilitiesHeader } from './core/constants';
import { authService } from '../../../store/fundingSource/fundingSource.service';

export const PayerCapabilities = () => {
    const [list, setList] = useState({ items: [], stats: { total: 0 }, nextPageToken: null });
    const [load, setLoad] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [filters, setFilters] = useState({});
    const [searchInput, setSearchInput] = useState({});
    const observerRef = useRef(null);

    const fetchData = useCallback(
        async (reset = false) => {
            if (load || !hasMore) return;
            setLoad(true);
            try {
                const res = await authService.getPayerCapabilitiesService({
                    pageSize: 50,
                    pageToken: reset ? null : list?.nextPageToken || null,
                    query: filters.displayName || null,
                });

                const items = res?.data?.items || [];
                const stats = res?.data?.stats || { total: 0 };
                const nextPageToken = res?.data?.nextPageToken || null;

                setList((prev) => ({
                    items: reset ? items : [...prev.items, ...items],
                    stats,
                    nextPageToken,
                }));

                if (!nextPageToken || (reset ? items.length : [...list.items, ...items].length) >= stats.total) {
                    setHasMore(false);
                } else {
                    setHasMore(true);
                }
            } catch (e) {
                setHasMore(false);
            } finally {
                setLoad(false);
            }
        },
        [load, hasMore, filters, list?.nextPageToken]
    );

    useEffect(() => {
        fetchData(true);
    }, [filters]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && hasMore && !load) {
                    fetchData();
                }
            },
            { threshold: 1 }
        );
        if (observerRef.current) observer.observe(observerRef.current);
        return () => {
            if (observerRef.current) observer.unobserve(observerRef.current);
        };
    }, [hasMore, load, fetchData]);

    const handleFiltersChange = (e) => {
        const { name, value } = e.target;
        setSearchInput((prev) => ({ ...prev, [name]: value }));
        setHasMore(true); // reset pagination
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setFilters(searchInput);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchInput]);

    return (
        <div className="payer-capabilities-wrapper">
            <div className="space-between">
                <p className="modal-header-title">{`Payer capabilities`}</p>
                {/*<p className="modal-header-title">{`Payer capabilities ${!load ? `(${list?.stats?.total || 0})` : ''}`}</p>*/}
                {/*<DownloadCsv type={'fundingSource'} />*/}
            </div>

            <div style={{ marginTop: 24 }}>
                <div className="payer-capabilities-header-wrapper">
                    {payerCapabilitiesHeader(list, setFilters)?.map((i, index) => (
                        <div style={{ width: i?.width }} key={index}>
                            <div className="payer-capabilities-header-total">
                                {i?.total && (
                                    <div>
                                        <p>{i?.total?.count}</p>
                                        <span>{i?.total?.name}</span>
                                    </div>
                                )}
                            </div>
                            <div className="payer-capabilities-header-title">
                                <p>{i?.name}</p>
                                {i?.search && (
                                    <div className="flex-align-center">
                                        <input
                                            type="text"
                                            name={i?.searchName}
                                            value={searchInput?.[i?.searchName] || ''}
                                            onChange={handleFiltersChange}
                                        />
                                        {load && filters && (
                                            <div style={{ position: 'relative' }}>
                                                <div style={{ position: 'absolute', right: 0, marginTop: '-14px' }}>
                                                    <MinLoader margin={'0'} color={'#475467'} position={'relative'} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {i?.subInfo && !load && <span>{i?.subInfo}</span>}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="payer-capabilities-body-wrapper">
                    {list?.items?.length
                        ? list?.items?.map((item, index) => (
                              <div key={index} className="flex-align-center">
                                  {payerCapabilitiesBody(item)?.map((i, k) => (
                                      <div className="payer-capabilities-body-row" key={k} style={{ width: i?.width }}>
                                          {i?.rowValue}
                                      </div>
                                  ))}
                              </div>
                          ))
                        : !load && <NoItemsYet text={`No Payer capabilities`} />}

                    {load && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
                            <Loader height={'60vh'} />
                        </div>
                    )}

                    <div ref={observerRef} style={{ height: 40, margin: '10px 0' }} />
                </div>
            </div>
        </div>
    );
};
